<template>
  <div class="card flex flex-col mt-3 items-center mx-4 max-h-[600px]"
    data-testid="new-user-demo-overlay">
    <!-- Text Content -->
    <div class="w-[90%] text-center md:text-2xl text-lg sm:text-xl break-words w-min-0"
     v-if="getNewUserDemoContent && getNewUserDemoContent.length > 0" :lang="lang">
      <p v-html="cleanContent(getNewUserDemoContent[slide].text[lang])" class="break-words"
        data-testid="new-user-demo-slide-text"
        :lang="lang"></p>
    </div>
    <div v-else class="w-[90%] text-center md:text-2xl text-lg sm:text-xl break-words">
      <h3 class="text-xl font-semibold text-gray-800 mb-3 break-words">
        {{ $t('NewUserDemo.noContentTitle') }}
      </h3>
      <p class="text-gray-600 break-words">
        {{ $t('NewUserDemo.noContentMessage') }}
      </p>
    </div>

    <!-- Image Section -->
    <!-- eslint-disable-next-line max-len -->
    <div class="flex relative w-full mt-3 h-96 min-h-96 max-h-96 content-between items-center justify-center">
      <img :src="mobileView ? getMobileImage : getImage" alt="picture" width="400" height="300"
        class="max-w-full max-h-full object-contain
         rounded-md md:w-[70%] sm:w-[88%] w-[60%] h-auto" />
      <button v-if="getNewUserDemoContent && getNewUserDemoContent.length > 1"
         class="absolute text-4xl left-3" @click.prevent="slideBack">
        <font-awesome-icon
         :class="{ 'hover:text-[var(--color-disabled)] cursor-not-allowed': isLeftDisabled }"
          class="hover:text-[var(--color-orange)]" icon="fa-chevron-left" />
      </button>
      <button v-if="getNewUserDemoContent && getNewUserDemoContent.length > 1"
         class="absolute text-4xl right-3" @click.prevent="slideForward">
        <font-awesome-icon
        :class="{ 'hover:text-[var(--color-disabled)] cursor-not-allowed': isRightDisabled }"
          class="hover:text-[var(--color-orange)]" icon="fa-chevron-right" />
      </button>
    </div>

    <!-- Description -->
    <div class="flex items-center text-center text-xl min-h-24 break-words" :lang="lang"
      v-if="getNewUserDemoContent && getNewUserDemoContent[slide]?.description">
      <p v-html="cleanContent(getNewUserDemoContent[slide].description[lang])" :lang="lang"
        class="break-words"></p>
    </div>

    <!-- Buttons -->
    <div class="mt-3">
      <button v-if="getNewUserDemoContent && getNewUserDemoContent.length > 0
       && slide !== getNewUserDemoContent.length - 1" @click.prevent="closePopup"
       id="skip-button"
       data-testid="new-user-demo-skip"
        class="btn-primary-accent w-64 py-2.5 px-5 text-base sm:text-lg">
       {{ $t('NewUserDemo.skipDemo') }}
      </button>
      <button @click.prevent="closePopup"
       id="skip-button" data-testid="new-user-demo-lets-go" v-else
       class="btn-primary-accent w-48 py-2.5 px-5 text-base sm:text-lg">
       {{ $t('NewUserDemo.letsGo') }}
      </button>
    </div>
  </div>
</template>
<script>
import defaultProfileImage from '@/assets/defaultProfileImage.js';
import { sanitizeHiddenChars } from '@/helpers/sanitizeText';

export default {
  name: 'NewUserDemoOverlayComponent',
  props: {
    overlay: {
      type: Object,
      default: null,
    },
    data: Object,
  },
  data() {
    return {
      loading: true,
      slide: 0,
      mobileView: false,
    };
  },
  mounted() {
    this.toggleLoading();
    this.checkForMobileView();
  },
  computed: {
    images() {
      try {
        return this.getNewUserDemoContent.map((s) => {
          const img = new Image();
          img.src = s.imageLink[this.lang];
          return img.src;
        });
      } catch (error) {
        console.error('Error loading images:', error);
        return [];
      }
    },
    mobileimages() {
      return this.getNewUserDemoContent.map((s) => {
        const img = new Image();
        img.src = s.imageLinkMobile[this.lang];
        return img.src;
      });
    },
    getNewUserDemoContent() {
      return this.$store.getters.getNewUserDemoContent;
    },
    getMobileImage() {
      const imageLink = this.mobileimages[this.slide];
      if (!imageLink || imageLink === '') {
        // eslint-disable-next-line global-require
        return defaultProfileImage;
      }
      return imageLink;
    },
    getImage() {
      const imageLink = this.images[this.slide];
      if (!imageLink || imageLink === '') {
        // eslint-disable-next-line global-require
        return defaultProfileImage;
      }
      return imageLink;
    },
    isRightDisabled() {
      return this.slide === this.getNewUserDemoContent.length - 1;
    },
    isLeftDisabled() {
      return this.slide === 0;
    },
    lang() {
      return this.$i18n.locale;
    },
    addBoxShadow() {
      return this.slide !== 0 && this.slide !== this.getNewUserDemoContent.length - 1;
    },
  },
  methods: {
    cleanContent(html) {
      return sanitizeHiddenChars(html);
    },
    debounce(func, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    async closePopup() {
      try {
        await this.$store.dispatch('newUserDemoComplete', {
          id: this.overlay._id,
        });
      } catch (error) {
        this.isSubmitting = false;
        this.$toast.add({
          severity: 'error',
          summary: error?.response?.data?.message,
          detail: '',
          life: 3000,
        });
      }
    },
    toggleLoading() {
      this.loading = false;
    },
    slideBack() {
      if (this.slide === 0) {
        return;
      }
      this.slide -= 1;
    },
    slideForward() {
      if (this.slide === this.getNewUserDemoContent.length - 1) {
        return;
      }
      this.slide += 1;
    },
    checkForMobileView() {
      this.mobileView = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
  },
};
</script>
<style scoped>
/* Ensure text wraps properly and doesn't overflow */
.break-words {
  word-wrap: normal;
  overflow-wrap: normal;
  hyphens: auto;
  hyphenate-character: auto;
  -webkit-hyphens: auto;
 -moz-hyphens: auto;
 -ms-hyphens: auto;
}

/* Ensure HTML content inside v-html also wraps */
:deep(p) {
  word-wrap: normal;
  overflow-wrap: normal;
  hyphens: auto;
  hyphenate-character: auto;
  max-width: 100%;
  -webkit-hyphens: auto;
 -moz-hyphens: auto;
 -ms-hyphens: auto;
}

:deep(h1), :deep(h2), :deep(h3), :deep(h4), :deep(h5), :deep(h6) {
  word-wrap: normal;
  overflow-wrap: normal;
  hyphens: auto;
  hyphenate-character: auto;
  max-width: 100%;
  -webkit-hyphens: auto;
 -moz-hyphens: auto;
 -ms-hyphens: auto;
}
</style>
